import fetch from '../plugin/axios/fetch.js'
import config from '../config/index'
import { checkBrowser } from '../plugin/channel/setUserChannel'
export async function auth (next) {
  const assertHasCode = function (paramsName) { //  判断是否存在code参数
    if (!paramsName) {
      return false
    }
    const url = location.href
    // const url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx19fa4559dc05322f&redirect_uri=https%3A%2F%2Fwx.emspost.com.cn%2Fweixin%2Fnewmail-api%2Ffeight%2Findex.html%23%2Findex&response_type=code&scope=snsapi_base&state=1#wechat_redirect'
    const reg = /[?&]([^=&#]+)=([^&#]*)/g
    const querySearchParams = url.match(reg) || []
    for (let item of querySearchParams) {
      const queryArray = item && item.substr(1).split('=')
      const queryParams = queryArray[0]
      const queryValue = queryArray[1]
      if (queryParams === paramsName && queryValue) {
        // sessionStorage.setItem('AUTH_CODE', queryValue)
        return queryValue
      }
    }
  }
  let params = null
  if (checkBrowser() === 'WECHAT') { // 微信环境
    params = 'code'
  }
  if (checkBrowser() === 'ALIPAY') { // 支付宝环境
    params = 'auth_code'
  }

  const isHasCode = assertHasCode(params)

  if (isHasCode) { // 判断是否有code
    sessionStorage.setItem('FREIGHT_AUTH_CODE', isHasCode)
  }

  if (localStorage.getItem('FREIGHT-TOKEN')) {
    await fetch.post({
      baseURL: process.env.VUE_APP_NODE_ENV === 'production' ? '/new-generation-token' : config.baseURL,
      url: 'user/doValidateToken',
      data: {
        'token': localStorage.getItem('FREIGHT-TOKEN')
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    fetch.setToken(localStorage.getItem('FREIGHT-TOKEN'))
    // window.flag = true
    next()
    return
  }
  // 存在token
  // fetch.setToken(localStorage.getItem('FREIGHT-TOKEN'))
  // next()
  // return

  if (!localStorage.getItem('FREIGHT-TOKEN')) { // 如果不存在token
    // 获取code来请求token
    // window.isFetchData = false
    let token = await getToken()
    fetch.setToken(token)
    console.log('FREIGHT-TOKEN   ' + token)
    // window.isFetchData = true
    localStorage.setItem('FREIGHT-TOKEN', token)
    localStorage.setItem('NEW-GENERATION-API-TOKEN', token)
    localStorage.setItem('NEW_BATCH_TOKEN', token)
    next()
  }
  async function getToken () {
    let code = sessionStorage.getItem('FREIGHT_AUTH_CODE')
    let appid = null
    if (checkBrowser() === 'WECHAT') { // 微信环境
      appid = process.env.VUE_APP_WX_APPID
    }
    if (checkBrowser() === 'ALIPAY') { // 支付宝环境
      appid = process.env.VUE_APP_ALIPAY_APPID
    }
    const data = await fetch.get({
      url: `${location.origin}${process.env.VUE_APP_AUTH_URL}/ndwz/o/tokenOauth`,
      params: {
        '__code': code,
        '__appid': appid
      }
    })
    return data.data.info.sacToken
  }
}
